<style scoped>
    .v-content {
        padding-top: 0;
    }

    .v-subheader {
        padding-left: 0;
    }

    td {
        text-align: center;
        white-space: nowrap
    }
    td i {
        margin-right: 0 !important;
    }
</style>
<template>
    <v-app>
        <v-card>
            <v-card-title>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table loading="true" :headers="headers" hide-actions :items="tableData" :search="search" class="elevation-1">
                <template slot="items" slot-scope="props">
                    <!--</td>-->
                    <td>{{props.item.name}}</td>
                    <td>{{props.item.department}}</td>
                    <td>{{props.item.type}}</td>
                    <td>
                        <v-icon v-show="props.item.status != '未完成'" color="success">check_circle</v-icon>
                        <v-icon v-show="props.item.status == '未完成'" color="error">cancel</v-icon>
                    </td>
                    <td>{{props.item.career}}</td>
                    <td>
                        <v-icon slot="activator" small color="primary" class="mr-2" @click="view_dialog = true;desc=props.item.desc.replace(/\n/g,'<br/>')">settings_overscan</v-icon>
                    </td>
                    <td>{{props.item.rate}}</td>
                    <td>{{props.item.innovation}}</td>
                    <td>{{props.item.perfection}}</td>
                    <td>{{props.item.integrity}}</td>
                    <td>{{props.item.diligence}}</td>
                    <td>{{props.item.undertake}}</td>
                </template>
                <template slot="no-data">
                    <p style="text-align: center">请搜索名字</p>
                </template>
            </v-data-table>
            <v-layout row justify-center>
                <v-dialog v-model="view_dialog" scrollable max-width="300px">
                    <v-card>
                        <v-divider></v-divider>
                        <v-card-text style="height: 300px;" v-html="desc"></v-card-text>
                        <v-card-actions>
                            <v-btn color="blue darken-1" flat @click="view_dialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card>

    </v-app>
</template>

<script>
	export default {
		components: {},
		data: () => ({
			search: '',
			desc: '',
			view_dialog: false,
			headers: [
				{text: '姓名', align: 'center', value: 'name', sortable: false},
				{text: '部门', align: 'center', value: 'department', sortable: false},
				{text: '类型', align: 'center', value: 'type', sortable: false},
				{text: '状态', align: 'center', value: 'status', sortable: false},
				{text: '职位', align: 'center', value: 'career', sortable: false},
				{text: '总结', align: 'center', value: 'desc', sortable: false},
				{text: '评级', align: 'center', value: 'rate'},
				{text: '创新', align: 'center', value: 'innovation', sortable: false},
				{text: '极致', align: 'center', value: 'perfection', sortable: false},
				{text: '正直', align: 'center', value: 'integrity', sortable: false},
				{text: '勤奋', align: 'center', value: 'diligence', sortable: false},
				{text: '担当', align: 'center', value: 'undertake', sortable: false},
				// {text: '详情', align: 'left', value: 'action'},
			],
			tableData: [],
		}),
		watch: {
			search: {
				handler(event) {
					let url = `http://pape.paquapp.com/searchUserEvaluate/?name=${this.search}`
					this.$axios.get(url).then((response) => {
						this.tableData = response
					});
				},
			}
		},
		activated(){
			this.search = this.$route.query.wd;
		},
		methods: {}
	}
</script>